export const criticalComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "critical-[request]" */
      /* webpackMode: "lazy" */
      /* webpackPreload: true */
      `../components/${handle}`
    ).then(module => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

export const importantComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "important-[request]" */
      /* webpackMode: "lazy" */
      /* webpackPrefetch: true */
      `../components/${handle}`
    ).then(module => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

export const deferredComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "deferred-[request]" */
      /* webpackMode: "lazy" */
      `../components/${handle}`
    ).then(module => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};
